// Other plugins.
import { getSubscriptionInfo } from '../../../subscription/interface/selectors'

// Helpers.
import BasicError, { callCodes } from '../../../errors'

// Libraries.
import { select } from 'redux-saga/effects'
import { logManager } from '../../../logs'

const log = logManager.getLogger('CALL')

/**
 * Gets the websocket id being used by the call.
 * @method getWebsocketId
 * @returns {Object} result Contains `websocketId` property or an `error` property
 * @returns {string} result.websocketId The websocket id being used by the call.
 * @returns {BasicError} result.error An error object on failure to find websocket id.
 */
export function * getWebsocketId () {
  const subscriptionInfo = yield select(getSubscriptionInfo)

  try {
    // Match anything after /websocket/ in the string. The ID should be the first result, which is the (.*) group.
    const websocketId = subscriptionInfo.notificationChannel.match(/\/websocket\/([^\s]+)/)[1]
    return { websocketId }
  } catch (e) {
    log.error(e.message)
    return {
      error: new BasicError({
        code: callCodes.GENERIC_ERROR,
        message: 'Websocket ID not found'
      })
    }
  }
}
